import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FileError, PopupNotValidFilesService } from './popup-not-valid-files.service';

/**
 * Component that shows a popup with the invalid files to be imported
 */
@Component({
    selector: 'cw-popup-not-valid-files',
    templateUrl: './popup-not-valid-files.component.html',
    standalone: false,
})
export class PopupNotValidFilesComponent implements OnInit, OnDestroy {
    groupedErrorFiles: Array<{ errorKey: string; filesError: FileError[] }> = [];
    onDestroy$: Subject<void> = new Subject();

    constructor(public popupNotValidFilesService: PopupNotValidFilesService) {}

    ngOnInit(): void {
        this.popupNotValidFilesService.openPopupNotValidFiles$.pipe(takeUntil(this.onDestroy$)).subscribe((listFiles: FileError[]) => {
            const mapfilesGroupedByError = new Map<string, FileError[]>();

            listFiles.forEach((fileError) => {
                if (!mapfilesGroupedByError.has(fileError.errorKey)) {
                    mapfilesGroupedByError.set(fileError.errorKey, []);
                }
                mapfilesGroupedByError.get(fileError.errorKey)?.push(fileError);
            });
            this.groupedErrorFiles = Array.from(mapfilesGroupedByError, ([errorKey, filesError]) => ({ errorKey, filesError }));
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
